import { Box, Flex, HStack, VStack } from "@chakra-ui/react";
import WidgetBox from "components/elements/WidgetBox/widget-box";
import PageHeader from "components/layout/PageHeader";
import { useContext, useEffect, useState } from "react";
import AmountStatusBar from "../elements/AmountStatusBar";
import StatDiscription from "../elements/StatBox/StatBoxDescription";
import LoanTargetCount from "components/widgets/LoanTargetCount";
import BarChartCard from "../elements/BarChart";
import LoanPipeline from "components/analytics/LoanPipelineProgress";
import { AnalyticsLoansTable } from "../elements/AnalyticsLoansTable";
import { SENIOR_MANAGEMENT_FIXED_FIELDS } from "utils/constants";
import { LoansContext } from "providers/loans";
import { LoanModel } from "providers/loans/loan.model";

function InvesterAnalytics() {
	const [filteredLoans, setFilteredLoans] = useState<LoanModel[]>([]);
	const { loans } = useContext(LoansContext);

	const stat1: any = "$50000000";

	const stat5: any = "10";
	const stat6: any = "+6.24%";

	useEffect(() => {
		const filtered = loans.filter(
			(loan: any) =>
				loan.status.isClosed === true || loan.status.isFunded === true
		);
		setFilteredLoans(filtered || []);
	}, [loans]);

	return (
		<>
			<PageHeader title="Investor Analytics" />
			<Flex justifyContent={"space-between"}>
				<HStack w={"32%"}>
					<StatDiscription
						stat={stat1}
						description="Total Invested Amount"
						number={99}
						mt="10px"
					/>
				</HStack>

				<HStack w={"32%"}>
					<StatDiscription
						stat={stat6}
						description="Performance of Investment"
						number={99}
						mt="10px"
					/>
				</HStack>
				<HStack w={"33%"}>
					<StatDiscription
						stat={stat5}
						description="Pipeline"
						helpNumber={"+3"}
						helpText="than last 5 years"
						helpColor="green"
						number={99}
						mt="-10px"
					/>
				</HStack>
			</Flex>

			<HStack spacing="18px" justifyContent="top" alignItems="top" mt={"24px"}>
				<HStack flex="5" spacing="22px" alignItems="top">
					<VStack flex="2" spacing="0px">
						<WidgetBox title="Loan Amount by Pipeline Status and Funding Date">
							<AmountStatusBar />
						</WidgetBox>
					</VStack>

					<Box flex="1">
						<HStack w={"100%"}>
							<StatDiscription
								stat={stat5}
								description="Total Loans Invested"
								helpNumber={"+0.5"}
								helpText="than last 5 years"
								helpColor="green"
								number={99}
								h={"128px"}
							/>
						</HStack>
						<HStack w={"100%"} mt={"24px"}>
							<LoanTargetCount h={"80px"} />
						</HStack>
					</Box>
				</HStack>
			</HStack>

			<WidgetBox title="Loan Margins">
				<BarChartCard />
			</WidgetBox>

			<HStack mt={"0"}>
				<WidgetBox title="Loan Pipeline">
					<LoanPipeline />
				</WidgetBox>
			</HStack>

			<HStack mt={"0"}>
				<WidgetBox title="Loans">
					<AnalyticsLoansTable
						columnsData={SENIOR_MANAGEMENT_FIXED_FIELDS}
						loans={filteredLoans}
					/>
				</WidgetBox>
			</HStack>
		</>
	);
}

export default InvesterAnalytics;
